module.exports = __webpack_public_path__ + "static/media/b99-fb-post.1246035c.png";